import { Avatar, Stack, Typography } from '@mui/material';
import { SuppliersContext } from 'Context/SuppliersContext';
import { useIsDesktop } from 'Hooks';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

export interface ICategory {
  image: string;
  text: string;
  url: string;
  supplierId: number;
}

export const Category = ({ image, text, url, supplierId }: ICategory) => {
  const { setSuppliersId } = useContext(SuppliersContext);
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();

  return (
    <Stack
      justifyContent='center'
      alignItems='center'
      gap={isDesktop ? '12px' : '6px'}
      sx={{
        p: isDesktop ? '20px 64px' : '12px 16px',
        width: isDesktop ? '274px' : '150px',
        bgcolor: '#FFF',
        borderRadius: '10px',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        whiteSpace: 'nowrap',
        ':hover': isDesktop
          ? {
              cursor: 'pointer',
              bgcolor: 'purple2.shade_200',
              borderColor: 'purple2.shade_400',
            }
          : {
              borderColor: 'primary.main',
            },
      }}
      onClick={() => {
        setSuppliersId(supplierId);
        navigate(url);
      }}
      onKeyDown={onEnterOrEscapeKeyDown}
      role='button'
      tabIndex={0}
    >
      <Avatar alt='' src={image} />
      <Typography variant={isDesktop ? 'body1' : 'h6'}>{text}</Typography>
    </Stack>
  );
};
